<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";

export default {
   page: {
      title: "Customer Details",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: { Layout, PageHeader },
   data() {
      return {
         title: "Customer Details",
         items: [
            {
               text: "Customers",
               href: "/customers",
            },

            {
               text: "Details",
               active: true,
            },
         ],

         customer: {
         },
         order: {},
         home_address: {},
         work_address: {},
         other_address: {},

       
         marker: { position: { lat: null, lng: null } },
            center: { lat: null, lng: null },
            current_place: null,

            marker_work: { position: { lat: null, lng: null } },
            center_work: { lat: null, lng: null },

            marker_other: { position: { lat: null, lng: null } },
            center_other: { lat: null, lng: null },


            mapOptions: {
               disableDefaultUI: true,
            },         

         text: '301, Durga Arcade, 3rd Floor, 41st Cross, Jaya Nagar, Bangalore, 560095',
         content: '2677, H.S.R Layout, Bangalore, 560102'

      };
   },
   mounted() {

   },
   created() {
         this.fetchCustomer();
      },
   methods: {
      fetchCustomer() {
            let url = "api/customer/profile?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.customer = responseData.customer;  
               this.order = responseData.orders;  
               this.home_address = responseData.home_address;  
               this.work_address = responseData.work_address;  
               this.other_address = responseData.other_address;
               if(this.home_address){

                           this.marker.position.lat = parseFloat(this.home_address.latitude);
                           this.marker.position.lng = parseFloat(this.home_address.longitude);

                           this.center.lat = parseFloat(this.home_address.latitude);
                           this.center.lng = parseFloat(this.home_address.longitude);
                           }  
                  if(this.work_address){

                              this.marker_work.position.lat = parseFloat(this.work_address.latitude);
                              this.marker_work.position.lng = parseFloat(this.work_address.longitude);

                              this.center_work.lat = parseFloat(this.work_address.latitude);
                              this.center_work.lng = parseFloat(this.work_address.longitude);
                              }  
                  if(this.other_address){

                        this.marker_other.position.lat = parseFloat(this.other_address.latitude);
                        this.marker_other.position.lng = parseFloat(this.other_address.longitude);

                        this.center_other.lat = parseFloat(this.other_address.latitude);
                        this.center_other.lng = parseFloat(this.other_address.longitude);
                        }  
                      })
              .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         getToken() {
         if (localStorage.getItem('sigofish_admin')) {
            var sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
            if(sigofish_admin.token) {
               this.token = sigofish_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         }, 
      showModal(modal) {
         this.$refs[modal].show();
      },

      hideModal(modal) {
         this.$refs[modal].hide();
      },
   }
}
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i
                              class='bx bx-chevrons-left'></i> Back</a>

                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">

                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <!-- <div class="col-sm-4"> -->
                                    <!-- <div class="avatar-md profile-user-wid mb-1">
                                       <img src="@/assets/images/users/avatar-2.jpg" alt
                                          class="img-thumbnail rounded-circle" />
                                    </div> -->

                                 <!-- </div> -->
                                 <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-15">
                                       {{customer.name}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i>
                                       {{customer.country_code}} {{customer.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{customer.email}}
                                    </p>

                                 </div>
                              </div>

                           </div>
                        </div>
                        <!-- end card -->
                        <div class="d-grid gap-2">
                           <!-- <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button> -->

                           <router-link :to="{ name: 'customers.edit' }" class="btn btn-primary">Edit
                              Profile</router-link>
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-shopping-cart font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Orders</p>
                                 <h4 class="mb-0">{{order}}</h4>
                              </div>
                           </div>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-7">
                       

                        <div class="card">
                           <div class="card-body">

                              <h4
                                 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                                 Address</h4>

                              <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                                 <b-tab active>
                                    <template v-slot:title>
                                       <span class="d-inline-block d-sm-none">
                                          <i class="fas fa-home"></i>
                                       </span>
                                       <span class="d-none d-sm-inline-block">Home</span>
                                    </template>
                                    <div class="table-responsive ">
                              <table class="table table-nowrap mb-0">
                                 <tbody v-if="home_address">
                                    
                                    <tr width="50%">
                                       <th scope="row">House/Flat No</th>
                                       <th>:</th>
                                       <td>{{home_address.house_no}}</td>
                                    </tr>

                                    <tr width="50%">
                                       <th scope="row">Building name</th>
                                       <th>:</th>
                                       <td>{{home_address.building_name}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Street</th>
                                       <th>:</th>
                                       <td>{{home_address.street}}</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Landmark</th>
                                       <th>:</th>
                                       <td>{{home_address.street}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Pincode</th>
                                       <th>:</th>
                                       <td>560095</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">Locality</th>
                                       <th>:</th>
                                       <td>Bangalore</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">State</th>
                                       <th>:</th>
                                       <td>Karnataka</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Latitude</th>
                                       <th>:</th>
                                       <td>{{home_address.latitude}}</td>
                                    </tr>

                                    <tr>
                                       <th scope="row">Longitude</th>
                                       <th>:</th>
                                       <td>{{home_address.longitude}}</td>
                                    </tr>

                                   <!-- 

                                    <tr>
                                       <th scope="row">Created on</th>
                                       <th>:</th>
                                       <td>17 Jan 2023, 10:00am</td>
                                    </tr> -->


                                 </tbody>
                                 <tbody v-else>
                                    Not added
                                 </tbody>
                              </table>
                           </div>
                                    <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="home_address">
                                       <h4
                                          class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                                          Location</h4>
                                       <b-row>

                                          <b-col md="12">
                                             <!-- <GmapMap v-if="home_address" :center="center" :zoom="18" map-style-id="roadmap"
                                                :options="mapOptions" style="width: 100%; height: 300px" ref="mapRef">
                                                <GmapMarker :position="marker.position" :clickable="false" :draggable="false" />
                                             </GmapMap> -->
                                             <GmapMap v-if="home_address"
                                                :center="center"
                                                :zoom="11"
                                                map-style-id="roadmap"
                                                :options="mapOptions"
                                                style="width: 100%; height: 300px"
                                                ref="mapRef">                              
                                                   <GmapMarker
                                                      :position="marker.position"
                                                      :clickable="false"
                                                      :draggable="false"
                                                   />
                                             </GmapMap>  
                                          </b-col>

                                       </b-row>
                                    </b-card>

                                 </b-tab>
                                 <b-tab active>
                                    <template v-slot:title>
                                       <span class="d-inline-block d-sm-none">
                                          <i class="fas fa-home"></i>
                                       </span>
                                       <span class="d-none d-sm-inline-block">Work</span>
                                    </template>
                                    <div class="table-responsive ">
                              <table class="table table-nowrap mb-0">
                                 <tbody v-if="work_address">
                                    
                                    <tr width="50%">
                                       <th scope="row">House/Flat No</th>
                                       <th>:</th>
                                       <td>{{work_address.house_no}}</td>
                                    </tr>

                                    <tr width="50%">
                                       <th scope="row">Building name</th>
                                       <th>:</th>
                                       <td>{{work_address.building_name}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Street</th>
                                       <th>:</th>
                                       <td>{{home_address.street}}</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Landmark</th>
                                       <th>:</th>
                                       <td>{{work_address.street}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Pincode</th>
                                       <th>:</th>
                                       <td>560095</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">Locality</th>
                                       <th>:</th>
                                       <td>Bangalore</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">State</th>
                                       <th>:</th>
                                       <td>Karnataka</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Latitude</th>
                                       <th>:</th>
                                       <td>{{work_address.latitude}}</td>
                                    </tr>

                                    <tr>
                                       <th scope="row">Longitude</th>
                                       <th>:</th>
                                       <td>{{work_address.longitude}}</td>
                                    </tr>

                                   <!-- 

                                    <tr>
                                       <th scope="row">Created on</th>
                                       <th>:</th>
                                       <td>17 Jan 2023, 10:00am</td>
                                    </tr> -->


                                 </tbody>
                                 <tbody v-else>
                                    Not added
                                 </tbody>
                              </table>
                           </div>
                                    <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="work_address">
                                       <h4
                                          class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                                          Location</h4>
                                       <b-row>

                                          <b-col md="12">
                                             <!-- <GmapMap v-if="home_address" :center="center" :zoom="18" map-style-id="roadmap"
                                                :options="mapOptions" style="width: 100%; height: 300px" ref="mapRef">
                                                <GmapMarker :position="marker.position" :clickable="false" :draggable="false" />
                                             </GmapMap> -->
                                             <GmapMap v-if="work_address"
                                                :center="center_work"
                                                :zoom="11"
                                                map-style-id="roadmap"
                                                :options="mapOptions"
                                                style="width: 100%; height: 300px"
                                                ref="mapRef2">                              
                                                   <GmapMarker
                                                      :position="marker_work.position"
                                                      :clickable="false"
                                                      :draggable="false"
                                                   />
                                             </GmapMap>  
                                          </b-col>

                                       </b-row>
                                    </b-card>

                                 </b-tab>
                                 <b-tab active>
                                    <template v-slot:title>
                                       <span class="d-inline-block d-sm-none">
                                          <i class="fas fa-home"></i>
                                       </span>
                                       <span class="d-none d-sm-inline-block">Other</span>
                                    </template>
                                    <div class="table-responsive ">
                              <table class="table table-nowrap mb-0">
                                 <tbody v-if="other_address">
                                    
                                    <tr width="50%">
                                       <th scope="row">House/Flat No</th>
                                       <th>:</th>
                                       <td>{{other_address.house_no}}</td>
                                    </tr>

                                    <tr width="50%">
                                       <th scope="row">Building name</th>
                                       <th>:</th>
                                       <td>{{other_address.building_name}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Street</th>
                                       <th>:</th>
                                       <td>{{home_address.street}}</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Landmark</th>
                                       <th>:</th>
                                       <td>{{other_address.street}}</td>
                                    </tr>

                                    <!-- <tr width="50%">
                                       <th scope="row">Pincode</th>
                                       <th>:</th>
                                       <td>560095</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">Locality</th>
                                       <th>:</th>
                                       <td>Bangalore</td>
                                    </tr> -->

                                    <!-- <tr width="50%">
                                       <th scope="row">State</th>
                                       <th>:</th>
                                       <td>Karnataka</td>
                                    </tr> -->

                                    <tr width="50%">
                                       <th scope="row">Latitude</th>
                                       <th>:</th>
                                       <td>{{other_address.latitude}}</td>
                                    </tr>

                                    <tr>
                                       <th scope="row">Longitude</th>
                                       <th>:</th>
                                       <td>{{other_address.longitude}}</td>
                                    </tr>

                                   <!-- 

                                    <tr>
                                       <th scope="row">Created on</th>
                                       <th>:</th>
                                       <td>17 Jan 2023, 10:00am</td>
                                    </tr> -->


                                 </tbody>
                                 <tbody v-else>
                                    Not added
                                 </tbody>
                              </table>
                           </div>
                                    <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="work_address">
                                       <h4
                                          class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                                          Location</h4>
                                       <b-row>

                                          <b-col md="12">
                                             <!-- <GmapMap v-if="home_address" :center="center" :zoom="18" map-style-id="roadmap"
                                                :options="mapOptions" style="width: 100%; height: 300px" ref="mapRef">
                                                <GmapMarker :position="marker.position" :clickable="false" :draggable="false" />
                                             </GmapMap> -->
                                             <GmapMap v-if="other_address"
                                                :center="center_other"
                                                :zoom="11"
                                                map-style-id="roadmap"
                                                :options="mapOptions"
                                                style="width: 100%; height: 300px"
                                                ref="mapRef2">                              
                                                   <GmapMarker
                                                      :position="marker_other.position"
                                                      :clickable="false"
                                                      :draggable="false"
                                                   />
                                             </GmapMap>  
                                          </b-col>

                                       </b-row>
                                    </b-card>

                                 </b-tab>

                              </b-tabs>
                           </div>
                        </div>

                         
                     </div>


                     <!-- <div class="card">
                        <div class="card-body">

                           <h4
                              class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                              Address</h4>

                           <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                              <b-tab active>
                                 <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                       <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">Home</span>
                                 </template>
                                 {{ text }}
                              </b-tab>
                              <b-tab>
                                 <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                       <i class="far fa-user"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">Work</span>
                                 </template>
                                 {{ content }}
                              </b-tab>
                              <b-tab>
                                 <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                       <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">Other</span>
                                 </template>
                                 {{ text }}
                              </b-tab>

                           </b-tabs>
                        </div>
                     </div>


                     <b-card header-class="bg-transparent border-light" class="border border-light mt-3">
                        <h4
                           class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">
                           Location</h4>
                        <b-row>

                           <b-col md="12">
                              <GmapMap v-if="customer.location" :center="center" :zoom="18" map-style-id="roadmap"
                                 :options="mapOptions" style="width: 100%; height: 300px" ref="mapRef">
                                 <GmapMarker :position="marker.position" :clickable="false" :draggable="false" />
                              </GmapMap>
                           </b-col>

                        </b-row>
                     </b-card> -->



                     <!-- </div> -->

                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <!-- <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="changePassword()">
            <b-row>
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"></b-form-input>


               </b-col>

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"></b-form-input>


               </b-col>

               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal> -->
      <!---- modal ends ----->

   </Layout>
</template>
